<template>
    <div class="employee-tab-inner">
        <!--<ul class="list-group mb-3 " v-if='errormsg'>
            <li class="list-group-item list-group-item-danger" v-for='data in errormsg'>{{data[0]}}</li>
        </ul>-->
        <b-overlay :show="showoverlay" rounded="sm">
            <div class="pf-reporting-tab payroll-reporting-tab" id="nav-tabContent-intro2" v-if="$acl['pf-employee-registration'] > 0">

                 <b-tabs content-class="mt-3 reports-tab-wrapper" nav-wrapper-class="mb-2 mt-2 reports-tab-nav">
                     <b-tab>
                            <template #title>
                                <div class="ibox-content-inner h-100 d-flex justify-content-center align-items-center flex-column text-center px-3 py-4 border rounded">

                                    <img v-bind:src="$api_url+'/images/Monthly-report-black.png'" class="light-mode-icon" /><img v-bind:src="$api_url+'/images/Monthly-report.png'" class="dark-mode-icon" />
                                    <h5>Employees with Waived PF Profit</h5>
                                    <p>Employees those have waived their profit from PF.</p>
                                    <b-button class="btn btn-primary">View Report</b-button>
                                </div>
                                <!-- <div class="report-title w-100 border-bottom font-weight-bold pb-2 mb-2">
                                    <img v-bind:src="$api_url+'/images/Monthly-report-black.png'" class="light-mode-icon" width="50px"/><img v-bind:src="$api_url+'/images/Monthly-report.png'" class="dark-mode-icon" width="50px"/>Employees with Waived PF Profit
                                </div>
                                <div class="report-intro">
                                    Employees those have waived their profit from PF.
                                </div>
                                <b-button class="mt-3">View</b-button> -->
                            </template>
                            <div class="">
                               <div v-if="em_reg_custom_list.length>0">

                                   <div class="card-header px-0 bg-transparent border-0">
                                        <div class="row no-margin">
                                            <div class="col-sm-6 pl-0" >
                                                <div class="employee-btn-holder" style="max-width:210px" v-if="$acl['pf-employee-registration'] > 1">
                                                    <b-button @click="exportUpdatetPF" ><b-icon icon="code-slash" ></b-icon> Download</b-button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                <!-- <common-list  :pageurl="this.$api_url" :is_action="0" :is_pf="is_n_pf" :checkbox="checkbox"  :appended_column="em_reg_appended_column" :key="em_reg_list_key" :company_options="em_reg_company_options" :employees="em_reg_custom_list" :default_column="em_reg_default_column" :primary_key="em_reg_primary_key"></common-list> -->
                                <common-list  :action_btn_text="action_btn_text" :pageurl="this.$api_url" :is_action="is_action" :is_pf="is_n_pf" :checkbox="checkbox"  :appended_column="em_reg_appended_column" :key="em_reg_list_key" :company_options="em_reg_company_options" :employees="em_reg_custom_list" :default_column="em_reg_default_column" :primary_key="em_reg_primary_key" v-on:childToParent="listReturn"></common-list> <!-- Rejwan: 29-01-2025 -->
                                </div>
                                <div v-else>

                                    <div v-if="show_loader" class="list-no-data">
                                        <span class="d-block text-center">Looking for relevant data..</span>
                                        <img v-bind:src="$api_url+'/images/download-loader.svg'" class="loader-logo" width="100px"/>
                                    </div>
                                    <div v-else class="list-no-data">
                                        Looks like there is no entries to show.
                                    </div>
                                </div>
                            </div>
                        </b-tab>
                    </b-tabs>
            </div>


        </b-overlay>

    </div>
</template>

<script>

    export default{
        mounted() {
            //if(this.employeedata.last_working_day == '0000-00-00')
                //this.fdata.last_working_day = '';

            this.showoverlay = false;
        },
        props: ['pageurl' , 'flg'],
        components: {
        },
        data(){
            const now = new Date()
            const today = new Date(now.getFullYear(), now.getMonth(), now.getDate())
            const minDate = new Date(today);
            return {

                cu:window.location.href,
                successmsg : false,
                warningmsg : false,
                dangermsg : false,
                showoverlay : true,
                pf_start_date : '',
                errormsg:[],
				hide:false,
                checkbox:0,
                show_loader:true,
                pgurl:this.$api_url,
                /* start pf signup variables */
                em_tmp_custom_list:[],
                min_date:minDate,

                /**Child Component property data */


                is_action:0, /* As this list have actions then is_action will be 1. Otherwise it will be 0 */
                list_key:0, /* Component Key */
                                /* Appended Column List  and there title and type */
                primary_key:'id',  /* Primary is the unique key of the list this key will be returned if the row is clicked,
                                            for employee list is employee_id, For loan list it is loan_id etc here it is employee_id*/

                /***Child Component property data */

                /**Child Component property data */

                is_n_pf:1,

                em_reg_appended_column:[
                    { value: "profit_waiver_from", text: "PF Profit Waived From",type: "date"},
                    { value: "profit_revive_from", text: "PF Profit Revived From",type: "date"},
                    // { value: "company_contribution", text: "Waived Employer Contribution",type: "number"}, // Rejwan: 23-04-2025 2 decimal
                    // { value: "employee_contribution", text: "Waived Employee Contribution",type: "number"}, // Rejwan: 23-04-2025 2 decimal
                    { value: "company_contribution", text: "Waived Employer Contribution",type: "amount"}, // Rejwan: 23-04-2025 2 decimal
                    { value: "employee_contribution", text: "Waived Employee Contribution",type: "amount"}, // Rejwan: 23-04-2025 2 decimal

                ],
                em_reg_tmp_custom_list:[],
                em_reg_company_options:[],
                em_reg_custom_list:[],
                em_reg_list_key:0, /* As this list have actions then is_action will be 1. Otherwise it will be 0 */
                em_reg_list_key:0,
                em_reg_primary_key:'id',
                em_reg_default_column:['name','email','jobposition','branch'], /* Default Column List */
                em_selected: [],
                selected: [],


                /***Child Component property data */
                curr_update_id:'',
                curr_approve_date:'',
                curr_update_employee:'',
                action_btn_text:'Download Log Report', // Rejwan: 29-01-2025

            }
        },
        methods:{
            // Start: Rejwan: 29-01-2025
            listReturn(data)
            {
                console.log(data.trustee);
                if(data.trustee == 1)
                {
                    this.getEmployeePfWaiveReviveLogReport(data.employee_id);
                }
            },
            getEmployeePfWaiveReviveLogReport(employee_id)
            {
                if(employee_id>0){
                    var curr_obj = this;

                    let formData = new FormData();
                    formData.append('employee_id', employee_id);
                    formData.append('d_type', 'excel');
                    this.loader = true;
                    
                    let url = this.$api_url + '/pf/report/waive-revive-log';
                    this.downloadBlobResponse(
                        axios.post(url, formData, { responseType: 'blob' }),
                        'loader'
                    );  
                }
            },
            // End: Rejwan: 29-01-2025

            formatMe(d)
            {
                return moment(d).format('DD/MM/YYYY');
            },

            validateState(ref)
            {
                if (
                    this.veeFields[ref] &&
                    (this.veeFields[ref].dirty || this.veeFields[ref].validated)
                ) {
                    return !this.veeErrors.has(ref);
                }
                return null;
            },

            /*start pf signup functions*/


        exportUpdatetPF: function(sltd='')
        {

            this.$bvToast.toast('It might take a while', {
                title: `Info`,
                variant: 'info',
                solid: true
            });
            console.log(this.em_selected);

            this.showoverlay = true;
            let formData = new FormData();
            if(sltd.length>0 && this.em_selected)
            formData.append('ids', this.em_selected);
        
            this.downloadBlobResponse(
                axios.post(this.$api_url + '/pf/waiver/export', formData, { responseType: 'blob' }),
                'showoverlay' // your loader key in this component
            );

        },


        download_file(fileURL)
            {
                if(!this.checkNet()) return false;

                var fileName = fileURL.substring(fileURL.lastIndexOf('/')+1);
                if (!window.ActiveXObject) {
                    var save = document.createElement('a');
                    save.href = fileURL;
                    save.target = '_blank';
                    //var filename = fileURL.substring(fileURL.lastIndexOf('/')+1);
                    save.download = fileName || filename;
                    if ( navigator.userAgent.toLowerCase().match(/(ipad|iphone|safari)/) && navigator.userAgent.search("Chrome") < 0) {
                            document.location = save.href;
                        }else{
                            var evt = new MouseEvent('click', {
                                'view': window,
                                'bubbles': true,
                                'cancelable': false
                            });
                            save.dispatchEvent(evt);
                            (window.URL || window.webkitURL).revokeObjectURL(save.href);
                        }
                }
                else if ( !! window.ActiveXObject && document.execCommand)     {
                    var _window = window.open(fileURL, '_blank');
                    _window.document.close();
                    _window.document.execCommand('SaveAs', true, fileName || fileURL)
                    _window.close();
                }
            },

            pfGetRegisteredEmployees: function()
            {
                let currentObj = this;
                currentObj.show_loader = true;
                axios.get(this.$api_url+'/pf/waiver/list' , {

                }).then(function(response){


                this.em_reg_custom_list = [];



                if (typeof response.data.employee_data !== 'undefined')
                {
                    /* Assingning the list */
                    this.em_reg_tmp_custom_list = response.data.employee_data;
                    /* Assingning the list */
                    this.em_tmp_custom_list = Object.keys(response.data.employee_data).map((key) => (response.data.employee_data[key]));
                }
                if (typeof response.data.options !== 'undefined')
                {
                    /* Assingning the Options */
                    this.em_reg_company_options = Object.keys(response.data.options).map((key) => (response.data.options[key]));
                }



                /* Now if we have actions in this grid then we have to create an additional key in each row and assing the actions for each row accordingly */

                if(this.em_tmp_custom_list.length > 0 )
                {
                    this.em_tmp_custom_list.forEach(element => {
                            if(element.employee_id > 0)
                            {
                                element.company_contribution = this.formatMoney(element.company_contribution);
                                element.employee_contribution = this.formatMoney(element.employee_contribution);

                                if(element.profit_waiver_from == '0000-00-00')
                                {
                                    element.profit_waiver_from = '';
                                }
                                if(element.profit_revive_from == '0000-00-00')
                                {
                                    element.profit_revive_from = '';
                                }
                            }
                        });


                this.em_reg_custom_list = this.em_tmp_custom_list;

                if(this.em_reg_custom_list.length > 0)
                {


                }
            }
            else
            {
                this.blankmsg = "No employee found as leaver";
            }


            this.em_reg_list_key = this.list_key + 1;
            currentObj.show_loader = false;

            }.bind(this)).catch(function (error){
                currentObj.show_loader = false;
                console.log(error);
                currentObj.serverError(error);

                });
            },
            // Start: Rejwan: 24-04-2025 2 decimal
            // formatMoney: function(amount){
            //     var money = Number(amount);

            //     if(this.$atl_company_number_format == 'no')
            //     {
            //         money = Math.round(money);
            //         money = money.toLocaleString();
            //     }
            //     else
            //     {
            //         money = money.toLocaleString();
            //         if(money=='NaN')
            //         money = amount;
            //         else{
            //         if(money.indexOf(".")<0)
            //         money = money+".00";
            //         }

            //     }

            //     return money;
            // },




        },
        created: function(){
            if(!this.checkNet()) return false;
            this.$validator.reset();
            this.pfGetRegisteredEmployees();
        }
    }
</script>
